/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import * as Sentry from '@sentry/react';

// @ts-expect-error variable is injected by vite.
if ( String( SENTRY_DNS ).length ) {
	Sentry.init( {
		// @ts-expect-error variable is injected by vite.
		dsn: SENTRY_DNS,
		// @ts-expect-error variable is injected by vite.
		environment: ENVIRONMENT,
		// @ts-expect-error variable is injected by vite.
		release: PROJECT_VERSION,
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration()
		],
		tracesSampleRate: 1.0,
		tracePropagationTargets: [
			// @ts-expect-error variable is injected by vite.
			APP_URL
		],
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0
	} );
}
